// ============================================
// DRAWER MANAGER
// ============================================

import Alpine from 'alpinejs';

export function registerDrawer(): void {
    Alpine.data('drawer', (side: 'left' | 'right' = 'left', mode: 'over' | 'push' | 'side' = 'over') => ({
        open: false,
        side,
        mode,
        isMobile: false,

        toggle(): void {
            if (this.mode === 'side' && !this.isMobile) {
                return;
            }
            this.open = !this.open;
            this.updateBodyScroll();
            this.updateContent();
        },

        close(): void {
            if (this.mode === 'side' && !this.isMobile) {
                return;
            }
            this.open = false;
            this.updateBodyScroll();
            this.updateContent();
        },

        showBackdrop(): boolean {
            return (this.mode === 'over') || (this.mode === 'side' && this.isMobile);
        },

        updateBodyScroll(): void {
            const shouldLock = this.mode === 'over' || (this.mode === 'side' && this.isMobile);
            if (shouldLock) {
                document.body.style.overflow = this.open ? 'hidden' : '';
            } else {
                document.body.style.overflow = '';
            }
        },

        updateContent(): void {
            const content = document.querySelector<HTMLElement>('.main-content');
            const navbar = document.querySelector<HTMLElement>('.navbar');
            const drawerWidth = '256px';

            const shouldPush = this.mode === 'push' || (this.mode === 'side' && !this.isMobile);

            if (shouldPush) {
                if (this.open) {
                    if (this.side === 'left') {
                        if (content) content.style.marginLeft = drawerWidth;
                        if (navbar) navbar.style.marginLeft = drawerWidth;
                    } else {
                        if (content) content.style.marginRight = drawerWidth;
                        if (navbar) navbar.style.marginRight = drawerWidth;
                    }
                } else {
                    if (content) {
                        content.style.marginLeft = '';
                        content.style.marginRight = '';
                    }
                    if (navbar) {
                        navbar.style.marginLeft = '';
                        navbar.style.marginRight = '';
                    }
                }
            } else {
                if (content) {
                    content.style.marginLeft = '';
                    content.style.marginRight = '';
                }
                if (navbar) {
                    navbar.style.marginLeft = '';
                    navbar.style.marginRight = '';
                }
            }
        },

        init(): void {
            this.checkMobile();

            window.addEventListener('keydown', (e: KeyboardEvent) => {
                if (e.key === 'Escape' && this.open) {
                    if (this.mode !== 'side' || this.isMobile) {
                        this.close();
                    }
                }
            });

            window.addEventListener('resize', () => this.checkMobile());

            if (this.mode === 'side' && !this.isMobile) {
                this.open = true;
            }
        },

        checkMobile(): void {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth < 1024;

            // Only toggle open state when actually crossing the breakpoint,
            // not on every resize (mobile address bar hide/show triggers resize)
            if (this.mode === 'side' && wasMobile !== this.isMobile) {
                this.open = !this.isMobile;
                this.updateBodyScroll();
                this.updateContent();
            }
        }
    }));
}
